const getLabelByRole = (roleValue) => {
  if (roleValue === "ROLE_OSHMA") {
    return "OSHMA";
  } else {
    return "AMA";
  }
};

const FORM_TEMPLATE_COLUMNS = [
  {
    field: "name",
    headerName: "Titulli i Formës",
    width: 400,
    minWidth: 400,
    flex: 1,
    editable: false,
  },
  {
    field: "description",
    headerName: "Përshkrimi",
    width: 300,
    flex: 1,
    editable: false,
  },

  {
    field: "role",
    headerName: "Roli i Përdorimit",
    width: 100,
    flex: 1,
    editable: false,
    renderCell: (params) =>
      !params.row.role ? "" : getLabelByRole(params.row.role),
  },
  // {
  //   field: "status",
  //   headerName: "Status",
  //   editable: false,
  // },
];

export default FORM_TEMPLATE_COLUMNS;
